'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _linksoft = require('linksoft');

var _linksoft2 = _interopRequireDefault(_linksoft);

var _actionTypes = require('./action-types');

var _actionTypes2 = _interopRequireDefault(_actionTypes);

var _values = require('lodash/values');

var _values2 = _interopRequireDefault(_values);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resx = (0, _localize2.default)("App");

(0, _jquery2.default)(document).on('blur', 'input[data-complaint-amount]', function (e) {
    var $input = (0, _jquery2.default)(this);
    var $row = $input.closest('tr');
    var tableApi = $row.closest('.dataTable').DataTable();
    var data = tableApi.row($row).data();

    var amount = parseInt((0, _jquery2.default)(this).val(), 10);
    if (!isNaN(amount)) {
        data.complaintAmount = amount;
    }

    _linksoft2.default.dispatchAction({ type: _actionTypes2.default.UPDATE, item: data, input: $input });
});

(0, _jquery2.default)(document).on('click', '#create-complaint', function () {
    var $this = (0, _jquery2.default)(this);
    var tableApi = (0, _jquery2.default)(".dataTable").DataTable();

    (0, _jquery2.default)("#complaint-summary").html('<div class=\'alert alert-info\'>' + resx.App.FillAmountToComplaintForItems + '</div>');
    var column = tableApi.column("complaintAmount:name");
    column.visible(true);
    $this.hide();
});

(0, _jquery2.default)(document).on('blur', '.input-complaint', function () {
    if ((0, _jquery2.default)(this).val()) {
        (0, _jquery2.default)("#save-complaint").show();
        (0, _jquery2.default)("#cancel-complaint").show();
    }
});

(0, _jquery2.default)(document).on('click', "#save-complaint", function () {
    var $this = (0, _jquery2.default)(this);
    (0, _jquery2.default)("[data-complaint-amount]").each(function () {
        (0, _jquery2.default)(this).val("");
    });
    $this.removeAttr("disabled");
    $this.hide();
    (0, _jquery2.default)("#cancel-complaint").hide();
    var tableApi = (0, _jquery2.default)(".dataTable").DataTable();
    tableApi.ajax.reload(null, false);
    var column = tableApi.column("complaintAmount:name");

    column.visible(false);
});

(0, _jquery2.default)(document).on('click', '#cancel-complaint', function () {
    var $this = (0, _jquery2.default)(this);
    (0, _jquery2.default)("#create-complaint").show();
    $this.hide();
    $this.removeClass("disabled");
    (0, _jquery2.default)("#save-complaint").hide();
    (0, _jquery2.default)("#complaint-summary").html('');
    (0, _jquery2.default)("[data-complaint-amount]").each(function () {
        (0, _jquery2.default)(this).val("");
    });
    var tableApi = (0, _jquery2.default)(".dataTable").DataTable();
    var column = tableApi.column("complaintAmount:name");
    column.visible(false);
});

(0, _jquery2.default)(function () {
    try {
        setTimeout(function () {
            var store = _linksoft2.default.store.get();
            store.subscribe(function (e) {
                var items = (0, _values2.default)((store.getState().complaints || { items: {} }).items).sort(function (a, b) {
                    return a.productName > b.productName;
                });
                (0, _jquery2.default)('#complaint-summary').html('<h3 class=\'complaint-title\'>' + res.App.ToComplaint + '</h3><hr/> ' + items.map(function (item) {
                    return '<div><span>' + item.productName + '</span>: <span>' + item.amount + '</span></div>';
                }).join(''));
            });
        }, 100);
    } catch (e) {
        console.log(e);
    }
});


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/complaints/initializer.js
// module id = 418
// module chunks = 0